<div *ngIf="!isExtension && !isMobile">
  <ng-container *ngFor="let ef of childTabs" >
    <a style="margin-top: 20px;" class="vote-tab-buttons" [routerLink]="'/' + ef.route" [ngClass]="{ 'active-ic-vote-tab': type === ef.route }">
      {{ef.label}}
    </a>
  </ng-container>
</div>
<div class="prompt-list" *ngIf="!categoriesLoading; else showSpinnder;">
  <div class="flex-container">
    <!-- <div class="environment-controls">
      <p-dropdown [options]="environments" [(ngModel)]="selectedEnvironment" optionLabel="label"
        placeholder="No Environment" styleClass="w-100"
        optionValue="value" (onChange)="onEnvironmentChange($event)">
      </p-dropdown>
      <i class="pi pi-eye view-environment-icon" title="View Environment" [ngClass]="{'disabled-icon': !selectedEnvironment || selectedEnvironment === 'none'}" (click)="viewEnvironment()" [ngStyle]="{'pointer-events': !selectedEnvironment || selectedEnvironment === 'none' ? 'none' : 'auto'}"></i>
      <i class="pi pi-plus add-environment-icon" title="Add Environment" (click)="showAddEnvironmentDialog()"></i>
    </div> -->
    <div class="search-container">
      <input #searchInput
      type="text" 
      pInputText 
      placeholder="Search here..." 
      (keydown.enter)="filterData($event)" 
      inputmode="search" />
    </div>
    <div class="card flex">
      <p-selectButton [options]="promptCategories" [(ngModel)]="selectedCategory" [multiple]="false" [disabled]="promptsLoading" (onChange)="onSelectionChange($event)" optionLabel="name"
        optionValue="value" styleClass="custom-select-button" class="custom-select-button"/>
      <a class="add-prompt-link" (click)="showAddPromptDialog()">Add a Prompt</a>
    </div>
  </div>
  
  <div *ngIf="!promptsLoading; else showLoaders;">
    <div *ngFor="let prompt of prompts">
      <p-card class="card card-container" [style]="{padding: 0, margin: '10px'}">
        <ng-template pTemplate="header">
          <div class="card-header">
            <span class="card-title">{{ prompt.name }}</span>
            <div class="icon-container">
              <i class="pi pi-copy copy-icon" title="Copy to Clipboard" (click)="copyToClipboard(prompt.description!)"></i>
              <i class="pi pi-book paste-icon" title="Paste to ChatGPT" *ngIf="isChatGPT" (click)="pasteToLLM(prompt.description!)"></i>
            </div>
          </div>
          <div class="card-subtitle">
            By {{prompt.submittedBy}}
          </div>
        </ng-template>

        <ng-template pTemplate="body">
          <p class="m-0" style="font-size: 12px;" [innerHTML]="prompt.description! | highlight"></p>
        </ng-template>
      </p-card>
    </div>
    <div *ngIf="prompts.length==0" class="no-data">
      <h2>No data available</h2>
    </div>
  </div>
</div>
<ng-template #showLoaders>
  <div style="display: flex; flex-direction: column; ">
    <p-skeleton width="90vw" styleClass="mb-3"></p-skeleton>
    <p-skeleton width="90vw" styleClass="mb-3"></p-skeleton>
    <p-skeleton width="90vw" styleClass="mb-3"></p-skeleton>
    <p-skeleton width="90vw" styleClass="mb-3"></p-skeleton>
    <p-skeleton width="90vw" styleClass="mb-3"></p-skeleton>
    <p-skeleton width="90vw" styleClass="mb-3"></p-skeleton>
    <p-skeleton width="90vw" styleClass="mb-3"></p-skeleton>
    <p-skeleton width="90vw" styleClass="mb-3"></p-skeleton>
    <p-skeleton width="90vw" styleClass="mb-3"></p-skeleton>
    <p-skeleton width="90vw" styleClass="mb-3"></p-skeleton>
    <p-skeleton width="90vw" styleClass="mb-3"></p-skeleton>
    <p-skeleton width="90vw" styleClass="mb-3"></p-skeleton>    
    <p-skeleton width="90vw" styleClass="mb-3"></p-skeleton>
    <p-skeleton width="90vw" styleClass="mb-3"></p-skeleton>
    <p-skeleton width="90vw" styleClass="mb-3"></p-skeleton>
    <p-skeleton width="90vw" styleClass="mb-3"></p-skeleton>
  </div>
</ng-template>
<ng-template #showSpinnder>
    <div class="loading-container">
    <p-progressSpinner
    class="spinner">
    </p-progressSpinner>
    <p>Loading categories, please wait...</p>
  </div>
</ng-template>
<p-dialog header="Add Prompt" [(visible)]="displayAddPromptDialog" [modal]="true" [closable]="true" [style]="{width: '50vw'}">
  <form #dialogForm="ngForm">
    <div class="grid">
      <div class="col-12">
        <label class="w-100">Category</label>
        <p-dropdown
          name="category"
          [required]="true"
          [options]="categories"
          [(ngModel)]="newPrompt.category"
          optionLabel="name"
          placeholder="Select a Category"
          class="w-100"
          #category="ngModel"
        ></p-dropdown>
        <small *ngIf="!newPrompt.category && category.touched" class="p-error">Category is required.</small>
      </div>

      <div class="col-12">
        <label class="w-100">Prompt Title</label>
        <input
          required
          id="title"
          name="title"
          type="text"
          pInputText
          [(ngModel)]="newPrompt.name"
          class="w-100"
          #title="ngModel"
        />
        <small *ngIf="!newPrompt.name && title.touched" class="p-error">Title is required.</small>
      </div>

      <div class="col-12">
        <label class="w-100">Prompt</label>
        <textarea
          required
          id="description"
          name="description"
          rows="5"
          pInputTextarea
          [(ngModel)]="newPrompt.description"
          class="w-100"
          #description="ngModel"
        ></textarea>
        <small *ngIf="!newPrompt.description && description.touched" class="p-error">Prompt description is required.</small>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button
      type="button"
      pButton
      label="Save"
      icon="pi pi-check"
      class="button-dark"
      (click)="savePrompt(dialogForm)"
      [disabled]="dialogForm.invalid"
      [loading]="promptSubmitting"
    ></button>
    <button
      type="button"
      pButton
      label="Cancel"
      icon="pi pi-times"
      class="p-button-secondary"
      (click)="closeForm(dialogForm)"
    ></button>
  </ng-template>
</p-dialog>


<p-dialog [header]="isViewMode? 'Update Environment': 'Add New Environment'" [(visible)]="displayAddEnvironmentDialog" [modal]="true" [closable]="false" [style]="{width: '80vw', height: '80vh', maxHeight: '80vh'}">   
  <div class="p-fluid">
    <div class="p-field">
      <label for="environmentTitle">Environment Title</label>
      <div class="flex-container" style="flex-direction: row;">
        <input id="environmentTitle" type="text" pInputText [(ngModel)]="newEnvironment.title" class="environment-title-input" [disabled]="isViewMode">
        <button type="button" pButton icon="pi pi-plus" label="Add Variable" (click)="addVariable()" class="add-variable-button"></button>
      </div>
    </div>
    <div class="p-field">
      <label for="variables">Variables</label>
      <p-table [value]="newEnvironment.variables">
        <ng-template pTemplate="header">
          <tr>
            <th>Variable</th>
            <th>Type</th>
            <th>Value</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-variable>
          <tr>
            <td><input type="text" pInputText [(ngModel)]="variable.name"></td>
            <td>
              <p-dropdown [options]="variableTypes" [(ngModel)]="variable.type" optionLabel="label" placeholder="Select Type" appendTo="body"></p-dropdown>
            </td>
            <td><input type="text" pInputText [(ngModel)]="variable.value"></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <p-footer>
    <button type="button" pButton label="Save" icon="pi pi-check" class="button-dark" (click)="saveEnvironment()"></button>
    <button type="button" pButton label="Cancel" icon="pi pi-times" class="p-button-secondary" (click)="displayAddEnvironmentDialog=false"></button>
  </p-footer>
</p-dialog>